import { render, staticRenderFns } from "./PurchaseSetting.vue?vue&type=template&id=bac9f934&scoped=true"
import script from "./PurchaseSetting.vue?vue&type=script&lang=js"
export * from "./PurchaseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac9f934",
  null
  
)

export default component.exports